import { call } from 'redux-saga/effects';
import download from 'downloadjs';
import { getAuthorizationHeader } from '@epi-repositories/ApiRepository';
import { parse as parseContentDisposition } from 'content-disposition';
import { createHeaders } from './FetchHelpers';

export function* downloadFile(
  url: string,
  headers: Record<string, string>,
  defaultFilename: string = 'file'
): Generator<any, any, any> {
  const method = 'GET';
  const resp: Response = yield call(fetch, url, {
    method,
    headers: createHeaders(headers)
  });

  if (resp.status >= 300) {
    return Promise.reject(new Error());
  }

  const dispositionHeader = resp.headers.get('content-disposition');
  const disposition = parseContentDisposition(dispositionHeader);
  const dispositionFilename =
    disposition && disposition.parameters && disposition.parameters.filename;

  const blob: Blob = yield resp.blob();
  return yield call(download, blob, dispositionFilename || defaultFilename);
}

export function* downloadFileAuthenticated(
  url: string,
  defaultFilename: string = 'file'
): Generator<any, any, any> {
  const header = yield call(getAuthorizationHeader, 'always');
  return yield call(downloadFile, url, header, defaultFilename);
}

export default {
  downloadFile
};
